// extracted by mini-css-extract-plugin
module.exports = {"managers":"managers__3F4tc","manager":"manager__VRE4U","counter":"counter__2N8Rs"};